import { getUrlParam } from './common';

export function isSEO(referrer: string) {
    let ref = referrer;
    const match = ref?.match(/:\/\/(.[^/]+)/);

    if (ref && match && match[1] === location.hostname) {
        return false;
    }

    ref = getUrlParam('adobe_mc_ref') || referrer || 'direct';
    const seoDomains = [
        'google',
        'ask.com',
        'bing.com',
        'yahoo',
        'aol',
        'yandex.com',
        'yam.com',
        'wow.com',
        'webcrawler.com',
        'voila.fr',
        'virgilio.it',
        'vinden.nl',
        'twcc.com',
        'thenexttask.com',
        'terra.com',
        'teoma.com',
        'startpagina.nl',
        'smarter.com',
        'seznam.cz',
        'verizon',
        'xfinity',
        'whiteskyservices',
        'pch',
        'mediacomcable',
        'search',
        'reference.com',
        'rambler.ru',
        'netscape.com',
        'naver.com',
        'msn.com',
        'lycos.com',
        'kvasir.no',
        'ixquick.com',
        'greenwichmeantime.com',
        'airtel',
        'frontier.com',
        'eniro.se',
        'ekolay.net',
        'earthlink.net',
        'duckduckgo.com',
        'dogpile.com',
        'att',
        'daum.net',
        'contenko.com',
        'baidu.com',
        'altavista.com',
        'alot.com',
        'alltheweb.com',
        'alice.com',
        'about.com',
        'wp.pl',
    ];

    return seoDomains.some((domain) => ref.includes(domain));
}
